export type KeyPagerProps = { startKey?: string; endKey?: string; hasMore?: boolean };

const KeyPager = ({ startKey = '', endKey = '', hasMore = false }: KeyPagerProps = {}) => ({
  startKey: String(startKey),
  endKey: String(endKey),
  hasMore: Boolean(hasMore),
});

export default KeyPager;
